/**
 * @desc 箱子绑定sku
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBoxBindSkuRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/bindSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
